import { createApp } from "vue";
import { createPinia } from "pinia";
import gsap from "gsap";
import maska from "maska";
import VueClipboard from "vue3-clipboard";
import { SnackbarService, Vue3Snackbar } from "vue3-snackbar";
import "vue3-snackbar/dist/style.css";
import http from "@/composables/api/http";

import App from "./App.vue";
import router from "./router";
import useRefreshLocalStorage from "@/composables/storage/useRefreshLocalStorage";

const app = createApp(App);
const { refreshLocalStorage } = useRefreshLocalStorage();

app.provide("http", http);
app.provide("$gsap", gsap);
app.use(maska);
app.use(createPinia());
app.use(router);
app.use(VueClipboard, {
  autoSetContainer: true,
  appendToBody: true,
});
app.use(SnackbarService);
app.component("vue3-snackbar", Vue3Snackbar);
app.mount("#space");
if (
  import.meta.env.VITE_ENV !== "local" &&
  import.meta.env.VITE_ENV !== "development"
) {
  refreshLocalStorage();
}
